import * as React from 'react';
import { Tooltip } from '@ixicare/ui';
import { t } from '~i18n';
import { Field } from '../schema';
import { labelWithUnit } from './FieldWrapper';

interface Props {
  field: Field;
}

// Renders a field's label text. When the field declares a `tooltip` i18n key,
// the label text becomes a hover trigger that surfaces the tooltip.
const FieldLabel: React.FC<Props> = ({ field }) => {
  const text = labelWithUnit(field.title, field.unit);

  if (!field.tooltip) return <>{text}</>;

  return (
    <Tooltip title={t(field.title)} content={t(field.tooltip)} hoverDelay={200} fullWidth>
      <u>{text}</u>
    </Tooltip>
  );
};

export default FieldLabel;
